// Packages and components
import { FormUp, FormDown } from 'grommet-icons';

// Helpers and utilities
import { TypographySettings } from '@theme/globals/typography';
import { pxToRem } from '@theme/utils/sizing';

const select = {
  icons: {
    color: 'black',
    margin: {
      horizontal: 'small',
    },
    up: FormUp,
    down: FormDown,
  },
  options: {
    container: {
      align: 'start',
      border: [
        {
          side: 'bottom',
          style: 'solid',
          size: '0.03125rem',
          color: 'gray-100',
        },
        {
          side: 'top',
          style: 'solid',
          size: '0.03125rem',
          color: 'gray-200',
        },
      ],
      extend: () => `
        backdrop-filter: blur(${pxToRem(75)});
      `,
      pad: 'small',
    },
    text: {
      color: 'text',
      size: TypographySettings.subhead.size,
      weight: TypographySettings.subhead.weight,
      margin: 'none',
    },
  },
  step: 20,
};
export default select;
